import React from "react";

type CompleteProps = {
  id: string;
  heading: string;
  content: string;
  isFacility?: boolean;
}

const Complete: React.FC<CompleteProps> = ({id, heading, content, isFacility=true}) => {

  return(
  <main id={id} className="wrapper">
    <section className="sec-contact">
      <div className="inner">
        <h1 className="c-ttl__01">{heading}</h1>
      </div>
    </section>
    
    <div className="sec-link">
      <div className="inner">
        <div className="link-block">
          <p className="c-txt__01 c-al--c">{content}</p>
          <a href={isFacility ? "/facility/top" : "/customer/top"} className="c-btn__01 c-btn__01--white">TOPページに戻る</a>
        </div>
      </div>
    </div>
  </main>
  )
}

export default Complete;